import React from 'react';

import Skeleton from 'UI/Skeleton';

export default class IntegrationSkeleton extends React.Component
{
    render()
    {
        return <div className="col-span-1 flex items-center bg-white shadow rounded-lg">
            <Skeleton className='flex-shrink-0 h-12 w-12 ml-4 my-2 rounded-full' />
            
            <div className="flex-1 px-4 py-2 truncate space-y-2">
                <Skeleton className='h-4 w-1/2 rounded' />
                <Skeleton className='h-4 w-1/4 rounded' />
            </div>
        </div>;
    }
}
